module.exports = __webpack_public_path__ + "static/12-3aac5f2c995739e0a83caedbb3f6a9f5.jpg";